import { AfterViewInit, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { catchError, Observable, throwError } from 'rxjs';
import { BulkOrderSummaryDataDTO } from 'src/app/core/models/system/order/order-bulk-summary-data.dto';
import { ExceptionsService } from 'src/app/core/services/utelize/general/exceptions-service';
import { FormBuilder, UntypedFormGroup } from '@angular/forms';
import { OrdersService } from '../../services/utelize/system/order/orders-service';

@Component({
  selector: 'app-dropdown-orders-bulk',
  templateUrl: './dropdown-orders-bulk.component.html',
  styleUrls: ['./dropdown-orders-bulk.component.scss']
})

export class DropdownBulkOrdersComponent implements AfterViewInit, OnInit {

  @Input() initialBulkOrderGuid : string  | undefined;
  @Input() initialCompanyId     : number  | undefined;
  
  @Output() selectOnChangeEvent: EventEmitter<string> = new EventEmitter<string>();

  private bulkOrdersIdData!: BulkOrderSummaryDataDTO[];

  public addOrEditForm!: UntypedFormGroup;
  
  constructor(
    private exceptionsService: ExceptionsService,
    private formBuilder      : FormBuilder,
    private ordersService    : OrdersService
  ) { }

  ngOnInit(): void {
    try {
      this.getDropdownData();

      let initialBulkOrderGuid=this.initialBulkOrderGuid==undefined ? "" : this.initialBulkOrderGuid;

      this.addOrEditForm = this.formBuilder.group({
        bulkOrderGuid: [initialBulkOrderGuid, []]
      });
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  ngAfterViewInit(){
    try {
      this.selectOnChange(undefined);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public getDropdownDataObjectArray() {
    try {
      return this.bulkOrdersIdData;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
       return (undefined);
    }
  }
  
  private getDropdownData() {
    try {
      let dataSource: Observable<BulkOrderSummaryDataDTO[]>;

      dataSource=this.ordersService.getBulkOrderIdAndDescription(this.initialCompanyId ?? -1);

      dataSource
      .pipe(
        catchError((error) => {
          return throwError(() => new Error(this.exceptionsService.formatHttpError(error)))
        })
      )
      .subscribe({
        next: data => {
          this.bulkOrdersIdData=(data as BulkOrderSummaryDataDTO[]);
         },
        error: error => {
          this.exceptionsService.handleException(new Error(error));
        }
      });
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public addToDropDown(bulkOrderGuid:string, menuText:string) {
    try {
      this.bulkOrdersIdData.unshift({id : bulkOrderGuid, description : menuText});

      this.addOrEditForm = this.formBuilder.group({
        bulkOrderGuid: [bulkOrderGuid, []]
      });

      this.selectOnChangeEvent.emit(bulkOrderGuid);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
       return (undefined);
    }
  }

  public refresh(companyId:number, bulkOrderGuid:string) {
    try {
      this.initialCompanyId=companyId;
      this.getDropdownData();

      this.addOrEditForm = this.formBuilder.group({
        bulkOrderGuid: [bulkOrderGuid, []]
      });

      this.selectOnChangeEvent.emit(bulkOrderGuid);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
       return (undefined);
    }
  }

  public selectOnChange(event: Event | undefined) {
    try {
      let bulkOrderGuid=this.addOrEditForm.controls["bulkOrderGuid"].value;

      this.selectOnChangeEvent.emit(bulkOrderGuid);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
       return (undefined);
    }
  }
}
